export default class Hero {
    constructor(contents, buttonTexts, url, image) {
        // {} instead of array to support stringify        
        this.contents = contents;
        this.buttonTexts = buttonTexts;

        this.url = url;
        this.image = image
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.buttonTexts)) { if(!value) { result = false; break; }; }

        if(result) result = this.url && this.image;

        return result;
    }
}